import { ComponentType, useState } from 'react';
import { influencer } from '@round/api';
import { InstagramProfileEmbed, TikTokProfileEmbed } from '@round/creatorbase-helpers/components';
import { EXPLORE_PLATFORMS, ExplorePlatform } from '../../helpers';
import styles from './CreatorProfileEmbeds.module.css';

const EMBEDS: Record<ExplorePlatform, ComponentType<{ username: string }>> = {
    tiktok: TikTokProfileEmbed,
    instagram: InstagramProfileEmbed,
};

type Props = {
    creator: influencer.CreatorSearchResult;
    platform: ExplorePlatform;
};

/**
 * The creator's profile embed on `platform`. Each platform's embed mounts the first time it is shown
 * and is only hidden after that, so switching back and forth never fetches an iframe again.
 */
export const CreatorProfileEmbeds = ({ creator, platform }: Props) => {
    const [shownPlatforms, setShownPlatforms] = useState<ExplorePlatform[]>([platform]);
    // Adjusted while rendering rather than in an effect, so a newly picked platform's embed mounts in
    // the same pass that hides the other one, instead of leaving a frame with neither.
    if (!shownPlatforms.includes(platform)) {
        setShownPlatforms([...shownPlatforms, platform]);
    }

    return (
        <div className={styles.container}>
            {EXPLORE_PLATFORMS.filter((embedPlatform) => shownPlatforms.includes(embedPlatform)).map(
                (embedPlatform) => {
                    const username = creator.platforms[embedPlatform][0]?.platform_username;
                    const Embed = EMBEDS[embedPlatform];

                    return (
                        <div key={embedPlatform} hidden={embedPlatform !== platform}>
                            {username && <Embed username={username} />}
                        </div>
                    );
                }
            )}
        </div>
    );
};
